module.exports = __webpack_public_path__ + "static/img/applets-code.81d4eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/footer/applets-code.jpg
// module id = RHuc
// module chunks = 32